import React, { useCallback, useMemo, useRef } from 'react';
import { JqueryClassFaker } from 'components/JqueryClassFaker';
import useWavesEffect from "../hooks/useWavesEffect";
import { openPage } from 'navigation/pageLocation';

const attributesToClasses = {
	block: 'btn-block',
	selected: 'selected',
	glow: 'pulse_glow',
	bright: 'bright',
	dark: 'dark',
	extraSmall: 'btn-xs',
	small: 'btn-sm',
	large: 'btn-lg',
	active: 'active',
	danger: 'btn-danger',
	success: 'btn-success',
	default: 'btn-default',
	transparent: 'transparent_button',
	borderOnly: 'border_only',
	modern: 'active_selectable_button--modern',
};

function ActiveSelectableButton({
	                                children,
	                                className,
	                                submit,
	                                href,
	                                ...restOfTheProps
                                }) {
	const ref = useRef(null);

	const onClick = useMemo(() => {
		if(href) {
			return (e) => {
				e.preventDefault();
				openPage(href, '_blank');
			};
		} else {
			return undefined;
		}
	}, [href]);


	const wavesClasses = useWavesEffect(ref);
	const classes = new JqueryClassFaker(wavesClasses);
	classes.add(className);
	_.each(attributesToClasses, (value, key) => {
		if(restOfTheProps[key]) {
			classes.add(value);
		}
		delete restOfTheProps[key];
	});

	let type = undefined;
	if(!href) {
		type = submit ? 'submit' : 'button';
	}

	const buttonProps = {
		onClick: onClick,
		className: `active_selectable_button shadowed-btn btn ${classes.toString()}`,
		type,
		href,
		ref: ref,
		...restOfTheProps
	};
	return React.createElement(href ? 'a' : 'button', buttonProps, children);
}

export default React.memo(ActiveSelectableButton);